module.exports = __webpack_public_path__ + "img/3.71713007.png";